"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCheckHeart = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.505 3.55c2.687-2.296 6.148-1.878 8.488.167 2.337-2.046 5.76-2.434 8.478-.176 2.973 2.472 3.33 6.687 1.04 9.633-.794 1.023-2.274 2.509-3.757 3.923-1.5 1.43-3.058 2.839-4.05 3.724l-.022.02c-.162.145-.325.29-.475.403a2 2 0 0 1-.64.339 2.015 2.015 0 0 1-1.149 0 2 2 0 0 1-.639-.338c-.15-.114-.312-.26-.475-.404l-.022-.02c-.992-.885-2.55-2.294-4.05-3.724-1.483-1.414-2.962-2.9-3.757-3.923C.176 10.216.598 6.034 3.505 3.55Zm12.702 5.657a1 1 0 0 0-1.414-1.414L11 11.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4.5-4.5Z", fill: "currentColor" }) }))); };
exports.default = SvgCheckHeart;
